import script from "./TrailerSearchApp.vue?vue&type=script&setup=true&lang=js"
export * from "./TrailerSearchApp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__